import { ReactComponent as RestaurantOutlinedIcon } from 'assets/images/icons/restaurant_outline.svg';

import { useTLang } from 'intl/intl';

import makeClasses from './WithoutItems.style';

export function WithoutItems() {
  const lang = {
    label: {
      first: useTLang({ id: 'substitutionFlow.015' }),
      second: useTLang({ id: 'substitutionFlow.016' }),
    },
  };

  const _classes = makeClasses();

  return (
    <article className={_classes.container}>
      <RestaurantOutlinedIcon className={_classes.icon} />
      <p className={_classes.label}>
        {lang.label.first}
        <br />
        {lang.label.second}
      </p>
    </article>
  );
}
